/// <reference path="./Item.ts" />
namespace HA.Core.HTML.Navigation {
    //noinspection TsLint
    export class AppInfoItem extends Item {
        /**
         *
         * @param data
         */
        public updateInfo(data: Map<any, any>) {
             log(['AppInfoItem::updateInfo', data]);
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
        }
    }
}
